import React, {useState, useEffect, useRef } from 'react';
import { Redirect } from 'react-router-dom';

import "../PaginaCustomer.css";
import "../content-styles.css"

import Swal from 'sweetalert2'

import * as Hosts from '../../../Hosts';
import {
	reqGET,
	reqPUT,
    passwordHash

} from '../../../Utils';

import { usarToken } from "../../../UseToken";

import Loader from '../../../loader'

import Navbar from "../Navbar/Navbar_00";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import Footer from "../Footer/Footer_00";

import { language } from './Language';

export default function Perfil(props) {
    const [, set_dados] = useState(null);
    const is_logged_in = useRef(null);

    const user_info = useRef({});
      
    const [dados_config, set_dados_config] = useState({});
    const [dados_navbar, set_dados_navbar] = useState({});

	const [isloading, setLoading] = useState(true)
    const [isRedirect, setRedirect] = useState(false)

    const [lang, set_lang] = useState('pt');

    const [pwd, set_pwd] = useState('');
    const [new_pwd, set_new_pwd] = useState('');
    const [new_pwd_conf, set_new_pwd_conf] = useState('');

    const [agree, setAgree] = useState(false);
    
    useEffect(() => {

        (async () => {
            let temp_token_info = await usarToken().getToken()
            let token_info = JSON.parse(temp_token_info)

            if(token_info !== undefined && token_info !== null && token_info.user_info !== undefined) {
                set_dados(is_logged_in.current = true)
            }
            else {
                set_dados(is_logged_in.current = false)
            }

            if(is_logged_in.current) {
                if(props.dados_navbar !== undefined && props.dados_navbar !== null && props.dados_navbar !== '') {
                    set_dados_navbar(props.dados_navbar)
                }
            }

            if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
                set_dados_config(props.dados_config)
            }

            let getClientInfo = async (id_user) => {
                return await reqGET(`${Hosts.SIMCore_API}/entities/${Hosts.companycode}/${id_user}`)
                    .then(res => {
                        //console.log('set_user_info', res.data[0])

                        set_dados(user_info.current = res.data[0])
                        // set_dados(user_info.current.notifications = [])

                        setAgree(res.data[0].info.marketing)

                        setLoading(false)
                    })
                    .catch(erro => console.log(erro))
            }
            if (token_info !== undefined && token_info !== null && token_info.user_info !== undefined && token_info.user_info !== null && token_info.user_info.id !== '') {
                getClientInfo(token_info.user_info.id)
            }
            else {
                setRedirect(true)
            }
        })()

        if(localStorage.getItem('lang') !== undefined  || localStorage.getItem('lang') !== null) {
            set_lang(localStorage.getItem('lang'))
        }

    }, [props]);

    const handleSubmit = async (e) => {
		e.preventDefault();

        console.log('user_info', user_info)

        if(user_info.current.info.name === '') {

            Swal.fire('', language[lang].name_error, 'info')
            return
        }
        if(user_info.current.info.email === '') {

            Swal.fire('', language[lang].email_error, 'info')
            return

        }

        if(new_pwd !== '') {
            let pwd_hash = passwordHash(pwd)
            if(pwd_hash === user_info.current.info.password) {

                if(new_pwd === new_pwd_conf) {
                    let npwd = passwordHash(new_pwd)
                    user_info.current.info.password = npwd

                }
                else {
                    Swal.fire('', language[lang].pwd_error, 'info')
                    return
                }

            }
            else {
                Swal.fire('', language[lang].old_pwd_error, 'info')
                return
            }
        }

        await reqPUT(`${Hosts.SIMCore_API}/entities`, user_info.current)

        Swal.fire('', language[lang].perfil_upadate_success, 'info')

	}

    const handle_change_info_documento_userinfo = (e) => {
        const { name, value } = e.target;

        if(name === 'email') {
            set_dados(user_info.current.info['username'] = value)
        }

        set_dados(user_info.current.info[name] = value)


    }

    const handle_change_info_documento_userinfo_addresses = (e) => {
        const { name, value } = e.target;

        set_dados(user_info.current.addresses[0][name] = value)

    }

    const handle_change_info_documento_userinfo_contacts = (e) => {
        const { name, value } = e.target;

        if (name === 'email')
            set_dados(user_info.current.info[name] = value)

        set_dados(user_info.current.contacts[0][name] = value)

    }

    const checkboxHandler = () => {
      // if agree === true, it will be set to false
      // if agree === false, it will be set to true
      setAgree(!agree);
      // Don't miss the exclamation mark
    }

    const checkboxHandler_reload = (value) => {
        //console.log('AGREE', agree)
        if (value === true)
            return true
        else 
            return false
        // if agree === false, it will be set to true
        //setAgree(!agree);
        // Don't miss the exclamation mark
    } 

    const handle_change_pwd = (e) => {
        const { name, value } = e.target;

        if(name === 'pwd') {
            set_pwd(value)
        }
        else 
        if(name === 'new_pwd') {
            set_new_pwd(value)
        }
        else if(name === 'new_pwd_conf') {
            console.log('conf')
            set_new_pwd_conf(value)
        }

    }

    return (
        isRedirect ? 
            <Redirect to={'/'} replace />
        :
            isloading ?
                <Loader />
            :

                <>
                    <Navbar pag_welcome={true} dados_config={dados_config} dados_navbar={dados_navbar} />
                    <Breadcrumb />
                    <main className='user-profile'>
                        <div className="container-fluid">
                            <div className="row">
                                <div className='col-12 bg-light py-5'>
                                    <div className='container'>
                                        <div className='row'>
                                            <div className='col-12 text-center'>
                                                <h3 className="titulo-primario">
                                                    {language[lang].dados_pessoais}
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container py-5">
                            <div className='row'>
                                <div className='col-12 col-lg-10 mx-auto'>
                                    <div className="row">
                                        <div className="col-12 col-md-8 mb-3">
                                            <label className="form-label" htmlFor="name">{language[lang].dados_nome} (*)</label>
                                            <input type="text" id="name" name="name" className="form-control" placeholder="" value={user_info.current.info.name} onChange={handle_change_info_documento_userinfo} />
                                        </div>

                                        <div className="col-12 col-md-4 mb-3">
                                            <label className="form-label" htmlFor="vat">{language[lang].dados_vat}</label>
                                            <input type="text" id="vat" name="vat" className="form-control" placeholder="" value={user_info.current.info.vat} onChange={handle_change_info_documento_userinfo} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 col-md-8 mb-3">
                                            <label className="form-label" htmlFor="email">{language[lang].dados_email} (*)</label>
                                            <input type="email" id="email" name="email" className="form-control" placeholder="" value={(user_info.current.contacts[0].email !== '' ? user_info.current.contacts[0].email : user_info.current.info.email)} onChange={handle_change_info_documento_userinfo_contacts} />
                                        </div>

                                        <div className="col-12 col-md-4 mb-3">
                                            <label className="form-label" htmlFor="mobile_phone">{language[lang].dados_mobile_phone}</label>
                                            <input type="text" id="mobile_phone" name="mobile_phone" className="form-control" placeholder="" value={user_info.current.contacts[0].mobile_phone} onChange={handle_change_info_documento_userinfo_contacts} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 col-md-8 mb-3">
                                            <label className="form-label" htmlFor="address_detail">{language[lang].dados_morada}</label>
                                            <textarea type="text" id="address_detail" rows="4" name="address_detail" className="form-control" placeholder="" value={user_info.current.addresses[0].address_detail} onChange={handle_change_info_documento_userinfo_addresses} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 col-md-4 mb-3">
                                            <label className="form-label" htmlFor="postal_code">{language[lang].dados_codigo_postal}</label>
                                            <input type="text" id="postal_code" name="postal_code" className="form-control" placeholder="" value={user_info.current.addresses[0].postal_code} onChange={handle_change_info_documento_userinfo_addresses} />
                                        </div>
                                        <div className="col-12 col-md-4 mb-3">
                                            <label className="form-label" htmlFor="localidade">{language[lang].dados_localidade}</label>
                                            <input type="text" id="localidade" name="localidade" className="form-control" placeholder="" value={user_info.current.addresses[0].localidade} onChange={handle_change_info_documento_userinfo_addresses} />
                                        </div>
                                        <div className="col-12 col-md-4 mb-3">
                                            <label className="form-label" htmlFor="country">{language[lang].dados_pais}</label>
                                            <input type="text" id="country" name="country" className="form-control" placeholder="" value={user_info.current.addresses[0].country} onChange={handle_change_info_documento_userinfo_addresses} />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" id="agree" onChange={checkboxHandler} defaultChecked={checkboxHandler_reload(agree)} />
                                                <label className="form-check-label small" htmlFor="agree">{language[lang].agree_marketing}</label>
                                            </div>
                                            <div className="mt-2 small">{language[lang].terms_conditions_required}</div>
                                        </div>
                                    </div>

                                    <div className='mt-5'>
                                        <div className="mb-3">
                                            <h3 className="titulo-secundario">{language[lang].dados_acesso}</h3>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-3">
                                                <label className="form-label" htmlFor="pwd">{language[lang].pwd}</label>
                                                <input type="password" id="pwd" name="pwd" className="form-control" placeholder="" value={pwd} onChange={handle_change_pwd} />
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <label className="form-label" htmlFor="new_pwd">{language[lang].new_pwd}</label>
                                                <input type="password" id="new_pwd" name="new_pwd" className="form-control" placeholder="" value={new_pwd} onChange={handle_change_pwd} />
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <label className="form-label" htmlFor="new_pwd_conf">{language[lang].new_pwd_conf}</label>
                                                <input type="password" id="new_pwd_conf" name="new_pwd_conf" className="form-control" placeholder="" defaultValue={new_pwd_conf} onBlur={handle_change_pwd} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='text-end mt-5'>
                                        <a href={Hosts.EMAIL_WEB_SITE_URL} className="btn btn-secondary me-3"> {language[lang].back} </a>
                                        <button className="btn btn-primary px-4" onClick={handleSubmit}> {language[lang].salvar} </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                    <Footer pag_welcome={true} dados_config={dados_config} dados_navbar={dados_navbar} />
                </>

    );
}